<template>
  <!-- -->
  <div class="sale-order-setting mini-component">
    <div class="desc">
      订单管理为系统固定组件，不同的角色看到的订单管理内容可能不同
    </div>
    <div v-if="showList">
      <div v-for="(item, idx) in bannerList" :key="idx" @click="toSetting(item, idx)">
        <alone-image-setting :data="item" :remove-able="false"/>
      </div>
    </div>
    <div v-else>
      <page-button @click="showList = true">返回</page-button>
      <alone-data v-model="currentData" @change="changeData" :show-tag="false" :show-background="false" :show-image="false" :show-path="false"/>
    </div>

  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import AloneImageSetting from "@/views/h5/common/sys/miniProgram/setting/component/AloneImageSetting.vue";

export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneImageSetting,
    AloneData
  },
  data() {
    return {
      showList: true,
      currentData: {},
      bannerList: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData || !this.data.componentData.length) {
        this.bannerList = [
          {text: "待付款", itemIcon: "huiyuanqiagoumai", textColor: "rgba(255, 0, 0, 1)", textBackground: "rgba(255, 0, 0, 0.3)", path: "", fontSize: "28"},
          {text: "待发货", itemIcon: "shouhou", textColor: "rgba(0, 174, 255, 1)", textBackground: "rgba(0, 174, 255, 0.3)", path: "", fontSize: "28"},
          {text: "待收货", itemIcon: "element-ui_check", textColor: "rgba(106, 0, 255, 1)", textBackground: "rgba(106, 0, 255, 0.3)", path: "", fontSize: "28"},
          {text: "已完成", itemIcon: "element-ui_tickets", textColor: "rgba(255, 119, 0, 1)", textBackground: "rgba(255, 119, 0, 0.3)", path: "", fontSize: "28"},
        ];
      } else {
        this.bannerList = this.data.componentData;
      }
    },
    toSetting(data, idx) {
      this.currentData = data;
      this.currentIndex = idx;
      this.showList = false;
    },
    // 数据变更
    changeData() {
      this.bannerList[this.currentIndex] = this.currentData;
      // 将数据向上级提交
      this.$emit("change", {
        ...this.data,
        componentData: this.bannerList
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>